<template>
    <div>
        <div style="text-align: left">
            <div class="searchbarcls">
                菜单名称:<el-input  size="small" v-model="searchForm.permissionname"  style="width: 200px;"></el-input>
                &nbsp;<el-button type="primary" icon="el-icon-search" size="small" @click="loadTableData()">查询</el-button>
            </div>
        </div>
        <el-table
                ref="selPermissionTable"
                background="true"
                :data="permissionTableData"
                border style="width: 100%;">
            <el-table-column type="index" label="序号" fixed="left" width="50"/>
            <el-table-column prop="pname" label="上级菜单"/>
            <el-table-column prop="permissionname" label="菜单名称"/>
            <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                    <el-button type="primary" plain size="mini" @click="selectedData(scope.row)">选择</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleSizeChange"
                :current-page="searchForm.currPage"
                :page-sizes="[30,60]"
                :page-size="20"
                layout="total,jumper, prev, pager, next,sizes"
                :total="searchForm.dataTotal">
        </el-pagination>
    </div>
</template>
<script>
    import {appjs} from "@/utiljs/apputil";
    export default {
        props: {
            setSelectedPermission:{
                type:Function
            }
        },
        data() {
            return {
                searchForm: {
                    currPage:1,
                    dataTotal:0,
                    permissionname:''
                },
                permissionTableData: []
            }
        },
        created() {
            this.loadTableData();
        },
        methods:{
            loadTableData(){
                let load = appjs.loading();
                let _self = this;
                let params = this.searchForm;
                appjs.httpRequest('permission/queryThreePermsssion',params).then(
                    (data)=>{
                        if(data.retCode&&data.retCode!="ok"){
                            appjs.showErrorMsg(data.retMsg)
                        }else{
                            _self.searchForm.dataTotal = data.dataList.length;
                            _self.permissionTableData = data.dataList;
                            console.log(data.dataList)
                            this.$refs.selPermissionTable.bodyWrapper.scrollTop =0;
                        }
                        appjs.unloading(load);
                    }
                ).catch(
                    (errmsg)=>{
                        appjs.showErrorMsg(errmsg)
                        appjs.unloading(load);
                    });
            },
            selectedData(rowdata){
                this.setSelectedPermission(rowdata);
            },
            handleSizeChange(val) {
                this.loadTableData();
            }
        }
    }
</script>
